module.exports = __webpack_public_path__ + "static/media/sending-linkedin-messages-1.af96d8ce.gif";